module.exports = __webpack_public_path__ + "static/media/logo.e8a8e9b2.svg";